// A Universal Link / App Link (the printed table QR's https://<host>/t/<placeId>/<table>, see
// places/helpers/table-code.ts) reaches the installed native app as a Capacitor `appUrlOpen` event
// carrying the full URL, which the in-app router can't navigate to - it only understands the path.
// Returns the in-app route for such a URL, or null for anything the router shouldn't be sent to: a
// non-URL, or the bare host (the OS opens the app at its last route, which is already correct).
export function deeplinkRoute(url: string): string | null {
	try {
		const { pathname, search } = new URL(url);
		return pathname === '/' && !search ? null : pathname + search;
	} catch {
		return null;
	}
}
